import React from 'react'

import type { IconProps } from './types'

const AirPopulation: React.FC<IconProps> = ({
  size = 40,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M21 17.96a4.01 4.01 0 0 0 2-3.46c0-2.2-1.8-4-4-4-.3-3.9-3.5-7-7.5-7S4.2 6.7 4 10.6c-1.7.4-3 2-3 3.9 0 1.473.807 2.766 2 3.46M11.5 6v0M15 7.3h0m-7 0h0m8.5 3.2h0m-10 0h0m4.8.5 2-2"
        stroke={color}
        stroke-width="1.25"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M11.254 11.5a.421.421 0 1 0 0-.842.421.421 0 0 0 0 .842Z"
        fill={color}
        stroke={color}
        stroke-width="1.25"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="m4.8 20.5.75-1.5m4.25 1.5L9.05 19m-3.5 0 1.526-3.053a.25.25 0 0 1 .447 0L9.05 19m-3.5 0h3.5m6.05 1a2.5 2.5 0 1 0-3-4 2.5 2.5 0 0 0 3 4Zm0 0 1 1m2.2-5.5v5"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default AirPopulation
